import { isDeviceReturnRequired as checkDeviceReturnRequired } from "@/pages/Checkout/checkout-form.util";
import { useUserInfo } from "@/common/providers/user-info-provider";

export const useGetManagerApprovalCard = () => {
  const amazonianInfo = useUserInfo();
  const manager = amazonianInfo?.manager;
  const isDeviceReturnRequired = checkDeviceReturnRequired(
    amazonianInfo?.basicInfo?.addresses?.home?.country ?? ""
  );
  const managerFullName = `${manager?.basicInfo?.firstName ?? ""} ${
    manager?.basicInfo?.lastName ?? ""
  }`.trim();
  const managerSubtitle = `L${manager?.jobInfo?.jobLevel ?? ""}, ${
    manager?.jobInfo?.businessTitle ?? ""
  }`;

  return {
    isDeviceReturnRequired,
    manager,
    managerFullName,
    managerSubtitle,
  };
};
